import { Divider } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { userSignOut } from 'actions/Auth';
import axios from 'axios';
import { BASE_URL_OSLOG, HOSTNAME_OSLOG } from 'constants/ActionTypes';
import createHistory from 'history/createHashHistory';
import React from 'react';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';

const history = createHistory();

class UserInfo extends React.Component {

    state = {
        anchorEl: null,
        open: false,
        openDialog: false,
        openDialogAbout: false
    };

    handleClick = event => {
        this.setState({ open: true, anchorEl: event.currentTarget });
    };

    handleRequestClose = (param) => {
        if (param === 'profile') {
            history.push('/app/profile');
        } else if (param === "about") {
            this.setState({ openDialogAbout: true })
        } else if (param === "contact") {
            this.setState({ openDialog: true })
        }
        this.setState({ open: false });
    };

    handleLogout = async () => {
        const URL = `${BASE_URL_OSLOG}/app/logout`;
        // console.log(URL)

        await axios({
            headers: {
                'Accept': 'application/json',
            },
            method: 'get',
            url: URL,
            withCredentials: true,
        }).then((response) => response).catch((error) => error.response);
        localStorage.removeItem('user_id');
        localStorage.removeItem('apiKey');
        localStorage.removeItem('rolename');
        localStorage.removeItem('name');
        localStorage.removeItem('menu_user');
        localStorage.removeItem('companyId');

        // // window.location = window.location.origin;
        // if (window.location.hostname === HOSTNAME_OSLOG) {
        //     //oslog
        //     window.location = BASE_URL_OSLOG + "/v5/";
        //     //advotics
        //     // window.location = BASE_URL_OSLOG + "/advotics/";
        // } else {
        //     window.location = window.location.origin;
        // }

        window.location = window.location.origin;

        // if(window.location.hostname === HOSTNAME_OSLOG){
        //     window.location = BASE_URL_OSLOG+"/v5/";
        // } else if (window.location.hostname === '202.47.70.196'){
        //     window.location = `${BASE_UR_API2}/epoool`;
        // } else if(window.location.hostname === 'linstasarta.oslog.id'){
        //     window.location = "http://linstasarta.oslog.id/";
        // } else {
        //     window.location = "http://localhost:4000";
        // }

    }

    handleClickImage = () => {
        history.push('/');
    }

    render() {
        const name = localStorage.getItem('name')
        return (
            <div className="user-profile d-flex flex-row align-items-center">

                <div onClick={this.handleClickImage} style={{ cursor: 'pointer' }}>
                    <Avatar
                        alt='...'
                        src=
                        // {
                        //     localStorage.companyId === '257' 
                        //         ? "assets/images/logo/diptapermata.png" 
                        //         : [ localStorage.companyId === '77' 
                        //             ? "assets/images/logo/firstlogistics.png"
                        //             : "assets/images/logo.png"
                        //         ]

                        // }
                        {(() => {
                            switch (localStorage.companyId) {
                                case '257':
                                    return ("assets/images/logo/diptapermata.png")
                                case '77':
                                    return ("assets/images/logo/firstlogistics.png")
                                case '286':
                                    return ("assets/images/logo/dutatrans.png")
                                case '542':
                                    return ("assets/images/ntc_19.png")
                                case '550':
                                    return ("assets/images/logo/quincus.png") 
                                case '554':
                                    return ("assets/images/logo/esway.png") 
                                case '728':
                                    return ("assets/images/advo_square.png")
                                case '723':
                                    return ("assets/images/logo-header/gamatechno_color.png")
                                default:
                                    return ("assets/images/logo.png") 
                            }
                        })()}
                        //src='assets/images/logo.png'
                        //src='assets/images/logoCiputra.png'
                        // src='assets/images/logo/armytrack.png'
                        // src='assets/images/logo/kitos.png'
                        //src='assets/images/favicon2.ico'
                        className="user-avatar"

                    />
                </div>

                <Dialog
                    fullWidth={true}
                    maxWidth="md"
                    open={this.state.openDialog}
                    onClose={() => this.setState({ openDialog: false })}
                    aria-labelledby="max-width-dialog-title"
                >
                    <DialogTitle id="max-width-dialog-title">Contact Us</DialogTitle>
                    <DialogContent>
                        <Divider />
                        <br />
                        <div className="row">
                            <div className="col-md-6">
                                <div>
                                    <h2>INTEGRASIA UTAMA</h2>
                                    <p>Radio Dalam square no. 1 A, Jalan Radio Dalam, Jakarta selatan 12140. Indonesia</p>
                                </div>
                                <div className="row">
                                    <div className="col-md-1"> <i className="zmdi zmdi-phone" /></div>
                                    <div className="col-md-11">+62 21 22773747</div>
                                </div>
                                <div className="row">
                                    <div className="col-md-1"> <i className="zmdi zmdi-email" /></div>
                                    <div className="col-md-11">cs.oslog@integrasiautama.com</div>
                                </div>
                                <div className="row">
                                    <div className="col-md-1"> <i className="zmdi zmdi-whatsapp" /></div>
                                    <div className="col-md-11">+62 877 8816 6111</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.0044331626746!2d106.78563931438252!3d-6.263144995466677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1a206b09c8b%3A0xc34e1845b9a02a81!2sIntegrasia+Utama.+PT!5e0!3m2!1sid!2sid!4v1496112901442"
                                    width="400"
                                    height="209"
                                    frameborder="0"
                                    style={{ border: 0 }}
                                    allowfullscreen></iframe>
                            </div>
                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openDialog: false })} color="primary">
                            Close
                    </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth={true}
                    maxWidth="sm"
                    open={this.state.openDialogAbout}
                    onClose={() => this.setState({ openDialogAbout: false })}
                    aria-labelledby="max-width-dialog-title"
                >
                    <DialogTitle id="max-width-dialog-title">About</DialogTitle>
                    <DialogContent>
                        <Divider />
                        <br />
                        <div className="row">
                            <div className="col-md-12">
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <img src='assets/images/logo.png'></img>
                                   
                                </div>
                                <div style={{display: "flex", justifyContent: "center", paddingTop: 50 }}>
                                        <h5> OSLOG JAVAZ - Version 5.0</h5>
                                </div>
                            </div>
                        </div>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openDialogAbout: false })} color="primary">
                            Close
                    </Button>
                    </DialogActions>
                </Dialog>


                {/* <div onClick={this.handleClickImage} style={{cursor: 'pointer'}}>
                    <img src="assets/images/logo/sistelindo.png" height="40px" width="40px"/>
                </div> */}

                <div className="user-detail">
                    <h4 className="user-name" onClick={this.handleClick}>{name} <i
                        className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
                    </h4>
                </div>
                <Menu className="user-info"
                    id="simple-menu"
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onClose={this.handleRequestClose}
                    PaperProps={{
                        style: {
                            width: 120,
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                    }}
                >
                    <MenuItem onClick={() => this.handleRequestClose('profile')}>
                        <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
                        <IntlMessages id="popup.profile" />
                    </MenuItem>
                    <MenuItem onClick={() => this.handleRequestClose('contact')}>
                        <i className="zmdi zmdi-phone zmdi-hc-fw mr-2" />
                        Contact Us
                    </MenuItem>
                    <MenuItem onClick={() => this.handleRequestClose('about')}>
                        <i className="zmdi zmdi-desktop-windows zmdi-hc-fw mr-2" />
                        About
                    </MenuItem>
                    <MenuItem onClick={this.handleLogout}>
                        <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />

                        <IntlMessages id="popup.logout" />
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

const mapStateToProps = ({ settings }) => {
    const { locale } = settings;
    return { locale }
};
export default connect(mapStateToProps, { userSignOut })(UserInfo);





// WEBPACK FOOTER //
// ./components/UserInfo/index.js